import Yup from 'utils/validation/yup-extensions';
import SchedulingSpecialtyTable from '../../../../ApplicationRequest/components/containers/1616BridgesEpic/components/SchedulingSpecialtyTable';

export const SpecialtySupplement = ({ formik }) => {
	return (
		<SchedulingSpecialtyTable
			helperText='Select ALL specialties for provider'
			formik={formik}
			name={FORM_FIELD_KEYS.SPECIALTIES}
			label={'Specialties'}
			visible
			isRequired
		/>
	);
};

export const FORM_FIELD_KEYS = {
	SPECIALTIES: 'specialties',
};

export const INITIAL_VALUES = {
	[FORM_FIELD_KEYS.SPECIALTIES]: [
		{
			specialtyId: null,
			specialtyName: null,
			isPrimary: true,
		},
	],
};

export const VALIDATION_SCHEMA = {
	[FORM_FIELD_KEYS.SPECIALTIES]: Yup.array()
		.of(
			Yup.object()
				.shape({
					specialtyId: Yup.string().required().nullable(),
					specialtyName: Yup.string()
						.required('Please search for and select a specialty.')
						.nullable(),
					isPrimary: Yup.bool(),
				})
				.nullable(),
		)
		.min(1, 'You must have at least one specialty.')
		.max(15, 'You can select no more than 15 specialties.'),
};
